import PromptDescription from "./PromptDescription";
import { StimulusMaterial } from "../stimulusMaterial/StimulusMaterial";
import { StimulusMaterialViewModel } from "../stimulusMaterial/stimulusMaterialApiSlice";
import SignLanguageURL from "./SignLanguageUrl";

interface PromptPanelProps {
	name: string;
	showName: boolean;
	renderedText: string;
	stimulusMaterials: StimulusMaterialViewModel[];
	showGenre: boolean;
	signLanguageVideoURL?: string;
	genre?: string;
	className?: string;
}

export default function PromptPanel(props: PromptPanelProps) {
	const displayName = props.showGenre
		? (props.genre == "Constructed Response" ? `${props.genre}: ` : `${props.genre} Prompt: `) +
			props.name
		: props.name;

	return (
		<div
			className={`${props.className} bg-gray-200 mt-8 p-4 lg:basis-0 lg:grow mr-4 rounded-md`}>
			{props.showName && <span className="font-semibold">{displayName}</span>}
			<PromptDescription className="mt-2" html={props.renderedText ?? ""} />
			{props.signLanguageVideoURL && (
				<SignLanguageURL className="mt-4" url={props.signLanguageVideoURL} />
			)}
			<StimulusMaterial className="mt-4" stimuli={props.stimulusMaterials} />
		</div>
	);
}
